<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style>
.mr20{margin-right:20px;}
.mr10{margin-right:10px;}
</style>



// WEBPACK FOOTER //
// src/App.vue